/**
 * Custom Axios instance mutator for Orval
 * This file provides a custom Axios instance for API requests in the frontend
 */
import axios, { AxiosRequestConfig, AxiosResponse } from 'axios'

/**
 * Create a custom Axios instance with the provided configuration
 * This instance will be used by the generated react-query hooks
 * @param config - Axios request configuration
 * @returns Axios instance with the provided configuration
 */
export const customInstance = async <T>(config: AxiosRequestConfig): Promise<AxiosResponse<T>> => {
  // Set the base URL for the backend API.
  // In development the backend URL is overridable through `API_URL` (inlined by
  // Parcel at build time) so E2E can point the frontend at a backend running on
  // a dedicated port. The default matches APP_ENV=dev in the backend's
  // environment.config.ts (3032); 3031 is the SD500 campaign's port.
  const baseURL =
    process.env.NODE_ENV === 'production'
      ? '/api' // In production, we'll proxy to the backend
      : process.env.API_URL || 'http://localhost:3032'

  return await axios({
    ...config,
    baseURL,
  })
}
